import { api } from '../../core/api.js';

function tenantPath(id, suffix) {
  const base = `/admin/tenants/${encodeURIComponent(id)}`;
  return suffix ? `${base}${suffix}` : base;
}

export function listTenants() {
  return api('/admin/tenants');
}

export function getTenant(id) {
  return api(tenantPath(id));
}

export function getMessages(id) {
  return api(tenantPath(id, '/messages'));
}

export function markMessagesRead(id) {
  return api(tenantPath(id, '/messages/read'), { method: 'POST', body: {} });
}

export function sendMessage(id, message) {
  return api(tenantPath(id, '/messages'), {
    method: 'POST',
    body: { message },
  });
}

export function getSessions(id) {
  return api(tenantPath(id, '/sessions'));
}

export function getCalendar() {
  return api('/admin/calendar');
}

export function addCalendarSlot(weekday, time) {
  return api('/admin/calendar/slots', {
    method: 'POST',
    body: { weekday, time },
  });
}

export function removeCalendarSlot(id) {
  return api(`/admin/calendar/slots/${encodeURIComponent(id)}`, { method: 'DELETE' });
}

export function createTenant(body) {
  return api('/admin/tenants', { method: 'POST', body });
}
